"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchField = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const input_styles_1 = require("@/components/common/input/input.styles");
require("@/components/common/input/input");
const utils_1 = require("@/utils");
require("@/components/common/icon");
require("@/components/common/icon-button/semantics/clear-button");
let SearchField = class SearchField extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.placeholder = '';
        this.disabled = false;
        this.size = 'medium';
        this.inputId = (0, utils_1.uniqueId)('input');
    }
    render() {
        return (0, lit_1.html) `
      <div class="textfield-control">
        <mm-icon name=${icon_names_1.ICON_NAMES.SEARCH}></mm-icon>
        <mm-input
          input-id=${this.inputId}
          .type=${'search'}
          .value=${this.value}
          .placeholder=${this.placeholder}
          aria-label=${this.placeholder || '검색'}
          ?disabled=${this.disabled}
          @input=${this.handleInput}
        ></mm-input>
        ${this.renderClearButton()}
      </div>
    `;
    }
    // 호스트는 포커스를 받지 않으므로 검색 입력으로 넘긴다.
    focus(options) {
        this.input?.focus(options);
    }
    renderClearButton() {
        return (0, lit_1.html) `
      <mm-clear-button
        aria-label="검색어 지우기"
        ?hidden=${!this.value || this.disabled}
        @click=${this.handleClearClick}
      ></mm-clear-button>
    `;
    }
    // mm-input의 input 이벤트를 여기서 멈추지 않으면, detail 없는 원본이 뒤따라 올라가 소비자의 값을 덮는다.
    handleInput(event) {
        const target = event.target;
        event.stopPropagation();
        this.commitValue(target.value);
    }
    handleClearClick(event) {
        event.stopPropagation();
        if (this.disabled || !this.value)
            return;
        this.commitValue('');
    }
    commitValue(value) {
        this.value = value;
        (0, utils_1.emit)(this, 'input', { value: this.value });
    }
};
SearchField.styles = [
    input_styles_1.inputStyles,
    (0, lit_1.css) `
      /* 값이 없어도 자리를 남겨, 내용 폭을 따르는 배치에서 지울 때 필드 폭이 줄지 않게 한다. */
      mm-clear-button[hidden] {
        display: inline-flex;
        visibility: hidden;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SearchField.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SearchField.prototype, "placeholder", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], SearchField.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], SearchField.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.query)('mm-input')
], SearchField.prototype, "input", void 0);
SearchField = __decorate([
    (0, decorators_js_1.customElement)('mm-searchfield')
], SearchField);
exports.SearchField = SearchField;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhcmNoZmllbGQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzZWFyY2hmaWVsZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWtFO0FBRWxFLG9FQUFnRTtBQUNoRSx5RUFBb0Y7QUFDcEYsMkNBQXdDO0FBQ3hDLG1DQUF3QztBQUN4QyxvQ0FBaUM7QUFDakMsa0VBQStEO0FBR3hELElBQU0sV0FBVyxHQUFqQixNQUFNLFdBQVksU0FBUSxnQkFBVTtJQUFwQzs7UUFXdUIsVUFBSyxHQUFHLEVBQUUsQ0FBQTtRQUNWLGdCQUFXLEdBQUcsRUFBRSxDQUFBO1FBQ0EsYUFBUSxHQUFHLEtBQUssQ0FBQTtRQUNqQixTQUFJLEdBQWMsUUFBUSxDQUFBO1FBRTdELFlBQU8sR0FBRyxJQUFBLGdCQUFRLEVBQUMsT0FBTyxDQUFDLENBQUE7SUFxRHJDLENBQUM7SUFuREMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7O3dCQUVTLHVCQUFVLENBQUMsTUFBTTs7cUJBRXBCLElBQUksQ0FBQyxPQUFPO2tCQUNmLFFBQVE7bUJBQ1AsSUFBSSxDQUFDLEtBQUs7eUJBQ0osSUFBSSxDQUFDLFdBQVc7dUJBQ2xCLElBQUksQ0FBQyxXQUFXLElBQUksSUFBSTtzQkFDekIsSUFBSSxDQUFDLFFBQVE7bUJBQ2hCLElBQUksQ0FBQyxXQUFXOztVQUV6QixJQUFJLENBQUMsaUJBQWlCLEVBQUU7O0tBRTdCLENBQUE7SUFDSCxDQUFDO0lBRUQsaUNBQWlDO0lBQ2pDLEtBQUssQ0FBQyxPQUFzQjtRQUMxQixJQUFJLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQTtJQUM1QixDQUFDO0lBRU8saUJBQWlCO1FBQ3ZCLE9BQU8sSUFBQSxVQUFJLEVBQUE7OztrQkFHRyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxDQUFDLFFBQVE7aUJBQzdCLElBQUksQ0FBQyxnQkFBZ0I7O0tBRWpDLENBQUE7SUFDSCxDQUFDO0lBRUQsdUVBQXVFO0lBQy9ELFdBQVcsQ0FBQyxLQUFZO1FBQzlCLE1BQU0sTUFBTSxHQUFHLEtBQUssQ0FBQyxNQUEwQixDQUFBO1FBQy9DLEtBQUssQ0FBQyxlQUFlLEVBQUUsQ0FBQTtRQUN2QixJQUFJLENBQUMsV0FBVyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQTtJQUNoQyxDQUFDO0lBRU8sZ0JBQWdCLENBQUMsS0FBWTtRQUNuQyxLQUFLLENBQUMsZUFBZSxFQUFFLENBQUE7UUFDdkIsSUFBSSxJQUFJLENBQUMsUUFBUSxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUs7WUFBRSxPQUFNO1FBRXhDLElBQUksQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLENBQUE7SUFDdEIsQ0FBQztJQUVPLFdBQVcsQ0FBQyxLQUFhO1FBQy9CLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFBO1FBQ2xCLElBQUEsWUFBSSxFQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsRUFBRSxLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUssRUFBRSxDQUFDLENBQUE7SUFDNUMsQ0FBQzs7QUFuRU0sa0JBQU0sR0FBRztJQUNkLDBCQUFXO0lBQ1gsSUFBQSxTQUFHLEVBQUE7Ozs7OztLQU1GO0NBQ0YsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7MENBQVc7QUFDVjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7Z0RBQWlCO0FBQ0E7SUFBM0MsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7NkNBQWlCO0FBQ2pCO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO3lDQUEyQjtBQUNsRDtJQUFsQixJQUFBLHFCQUFLLEVBQUMsVUFBVSxDQUFDOzBDQUE0QjtBQWZuQyxXQUFXO0lBRHZCLElBQUEsNkJBQWEsRUFBQyxnQkFBZ0IsQ0FBQztHQUNuQixXQUFXLENBcUV2QjtBQXJFWSxrQ0FBVyJ9